export default [
  {
    year: 2018,
    total_contributors: 443,
    total_merged_mrs: 1517,
  },
  {
    year: 2019,
    total_contributors: 886,
    total_merged_mrs: 2424,
  },
  {
    year: 2020,
    total_contributors: 802,
    total_merged_mrs: 2833,
  },
  {
    year: 2021,
    total_contributors: 778,
    total_merged_mrs: 3193,
  },
  {
    year: 2022,
    total_contributors: 798,
    total_merged_mrs: 3250,
  },
  {
    year: 2023,
    total_contributors: 876,
    total_merged_mrs: 3072,
  },
  {
    year: 2024,
    total_contributors: 848,
    total_merged_mrs: 3002,
  },
];
